module.exports = __webpack_public_path__ + "static/media/[Annual_Oration]2016.e44496cd.md";